import SearchSelect from "@ui-components/SearchSelect";
import React, {useContext, useState} from "react";
import apiRequest from "@services/apiRequest";
import CountryContext from "../CountryContext";
import {FormattedMessage} from "react-intl";
import Checkbox from "../ui-components/Checkbox";


/**
 * This component is used as select on tables that needs
 * to fetch data from the backend.
 * It integrates with mu-tables events to refresh the table
 * based on selected filters.
 */
const COMPONENT_STYLE_OVERRIDE = {
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "2px 8px",
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    padding: "2px 8px",
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: "1.3rem",
    borderColor: "transparent",
    boxShadow: "none !important",
    "&:hover": {
      borderColor: "transparent",
    },
    backgroundColor: "transparent",
    minHeight: "33px",
    cursor: "pointer",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    position: "absolute",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    position: "absolute",
  }),
  input: (provided, state) => ({
    input: {
      border: 0,
      outline: 0,
      boxShadow: "none !important",
    },
  }),
}

const casInsenstive = (originalArray) => {
  const lowercaseArray = originalArray.map(str => str.toLowerCase());
  // Step 2: Remove duplicates using a Set
  const uniqueSet = new Set(lowercaseArray);
  // Step 3: Convert the Set back to an array
  const uniqueArray = [...uniqueSet];
  return uniqueArray;
}

const SuggestedUsersAsyncPaginatedTableFilter =
  ({
  type,
  columnDef,
  onFilterChanged,
  limit = 20,
  selectDisabled = false,
  onChangeExcludeNulls,
  ...props
   }) => {
    // context
    const {country: {code}} = useContext(CountryContext);
    
    const [selected, setSelected] = useState(null);
    const [checked, setChecked] = useState(false);

    const triggerFilterChanged = (s) => {
      if (s === null || s.length === 0) {
        onFilterChanged((columnDef).tableData.id, null);
      } else {
        onFilterChanged(
          (columnDef).tableData.id,
          s.map((option) => option.value)
        );
      }
    }

    return (
      // @ts-ignore
      <div>
        {!selectDisabled && <SearchSelect
          loadOptions={async (text, callback) => {
            const results = await apiRequest.get("/suggested_users/distinct_column_values", {
              params: {
                column: columnDef.field,
                value: text,
              }
            })
            // case insensitive
            const caseInsensitiveResults = casInsenstive(results)
            const options = caseInsensitiveResults.map((result) => {
              return {
                value: result,
                label: result,
              }
            })
            callback(options)
          }}
          onChange={(s) => {
            triggerFilterChanged(s)
            setSelected(s);
          }}
          value={selected}
          isMulti={true}
          mainStyle="border-2 border-kerakoll-400 mt-1 mb-0"
          componentStyle={COMPONENT_STYLE_OVERRIDE}
          noOptionsMessage={() => <FormattedMessage id="type_to_search"/>}
          isClearable={true}
          inputStyle={{position: "relative"}}
        />}
        <Checkbox
          checked={checked}
          onChange={(e)=>{
            setChecked(e.target.checked)
            onChangeExcludeNulls(e.target.checked)
            triggerFilterChanged(selected)
          }}
          style={{marginRight: "1rem"}}
        />
        <FormattedMessage id="remove missing values" defaultMessage={"rimuovi celle vuote"}/>
      </div>
    )
  }

export default SuggestedUsersAsyncPaginatedTableFilter;

